export default "__VITE_ASSET__583e5dd6__"